// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3EWZ8","inputWrap":"Table_inputWrap__2UkEi","col":"Table_col__3MCA9","bmiTooltip":"Table_bmiTooltip__3mLUZ"};